import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

/* Layout */
import Layout from '../views/layout/Layout'

/**
 * hidden: true                   if `hidden:true` will not show in the sidebar(default is false)
 * alwaysShow: true               if set true, will always show the root menu, whatever its child routes length
 *                                if not set alwaysShow, only more than one route under the children
 *                                it will becomes nested mode, otherwise not show the root menu
 * redirect: noredirect           if `redirect:noredirect` will no redirct in the breadcrumb
 * name:'router-name'             the name is used by <keep-alive> (must set!!!)
 * meta : {
    title: 'title'               the name show in submenu and breadcrumb (recommend set)
    icon: 'svg-name'             the icon show in the sidebar,
  }
 **/
export const constantRouterMap = [
  {
    path: '/login',
    component: () => import('@/views/login/index'),
    hidden: true
  },
  {
    path: '/404',
    component: () => import('@/views/404'),
    hidden: true
  },
  {
    path: '/',
    redirect: '/userOrderManage/userManList',
    hidden: true
  },
]

export const asyncRouterMap = [
  
  {
    path: '/webKhConfiguration',
    component: Layout,
    redirect: '/webKhConfiguration/khBannerList',
    name: 'webKhConfiguration',
    meta: {
      title: '多仑官网配置',
      icon: 'product-list'
    },
    children: [{
        path: 'khBannerList',
        name: 'khBannerList',
        component: () => import('@/views/webKhConfiguration/khBannerList'),
        meta: {
          title: '轮播图片管理',
          icon: 'product-list'
        }
      },{
        path: 'afterSalesApply',
        name: 'afterSalesApply',
        component: () => import('@/views/webKhConfiguration/afterSalesApply'),
        meta: {
          title: '售后申请',
          icon: 'product-list'
        }
      },{
        path: 'contact',
        name: 'contact',
        component: () => import('@/views/webKhConfiguration/contact'),
        meta: {
          title: '联系我们',
          icon: 'product-list'
        }
      },{
        path: 'productNo',
        name: 'productNo',
        component: () => import('@/views/webKhConfiguration/productNo'),
        meta: {
          title: '产品型号',
          icon: 'product-list'
        }
      },
    ]
  },
  
  



  {
    path: '/system',
    component: Layout,
    redirect: '/system/notice',
    name: 'System',
    meta: {
      title: '系统',
      icon: 'system'
    },
    children: [{
        path: 'notice',
        name: 'Notice',
        component: () => import('@/views/system/notice/index'),
        meta: {
          title: '公告管理',
          icon: 'system-notice'
        }
      },
      {
        path: 'params',
        name: 'Params',
        component: () => import('@/views/system/params/index'),
        meta: {
          title: '参数配置',
          icon: 'system-aboutus'
        }
      },
    ]
  },
  {
    path: '/user',
    component: Layout,
    redirect: '/user/userList',
    name: 'User',
    meta: {
      title: '客户',
      icon: 'system'
    },
    children: [{
      path: 'userList',
      name: 'UserList',
      component: () => import('@/views/user/userList/index'),
      meta: {
        title: '客户列表',
        icon: 'user-yonghu'
      }
    }]
  },
  
  
  

  {
    path: '/ums',
    component: Layout,
    redirect: '/ums/admin',
    name: 'ums',
    meta: {
      title: '权限',
      icon: 'ums'
    },
    children: [{
        path: 'admin',
        name: 'admin',
        component: () => import('@/views/ums/admin/index'),
        meta: {
          title: '客户列表',
          icon: 'ums-admin'
        }
      },
      {
        path: 'role',
        name: 'role',
        component: () => import('@/views/ums/role/index'),
        meta: {
          title: '角色列表',
          icon: 'ums-role',
          iskeepAlive:true
        }
      },
      {
        path: 'allocMenu',
        name: 'allocMenu',
        component: () => import('@/views/ums/role/allocMenu'),
        meta: {
          title: '分配菜单'
        },
        hidden: true
      },
      {
        path: 'allocResource',
        name: 'allocResource',
        component: () => import('@/views/ums/role/allocResource'),
        meta: {
          title: '分配资源'
        },
        hidden: true
      },
      {
        path: 'menu',
        name: 'menu',
        component: () => import('@/views/ums/menu/index'),
        meta: {
          title: '菜单列表',
          icon: 'ums-menu'
        }
      },
      {
        path: 'addMenu',
        name: 'addMenu',
        component: () => import('@/views/ums/menu/add'),
        meta: {
          title: '添加菜单'
        },
        hidden: true
      },
      {
        path: 'updateMenu',
        name: 'updateMenu',
        component: () => import('@/views/ums/menu/update'),
        meta: {
          title: '修改菜单'
        },
        hidden: true
      },
      {
        path: 'resource',
        name: 'resource',
        component: () => import('@/views/ums/resource/index'),
        meta: {
          title: '资源列表',
          icon: 'ums-resource'
        }
      },
      {
        path: 'resourceCategory',
        name: 'resourceCategory',
        component: () => import('@/views/ums/resource/categoryList'),
        meta: {
          title: '资源分类'
        },
        hidden: true
      },{
        path: 'staffList',
        name: 'staffList',
        component: () => import('@/views/ums/staffList/index'),
        meta: {
          title: '员工管理',
          icon: 'ums-admin'
        }
      },
    ]
  },

  {
    path: '*',
    redirect: '/404',
    hidden: true
  },
]

export default new Router({
  // mode: 'history', //后端支持可开
  scrollBehavior: () => ({
    y: 0
  }),
  routes: constantRouterMap
})



// WEBPACK FOOTER //
// ./src/router/index.js